import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "semantic-ui-react";
import { closeModal, openModal } from "../../../redux/Modals/ModalActions";
import { AppColumn } from "../../UI/Layouts";
import RegistrationPage from "../../Authentication/RegistrationPage";

const actions = {
  closeModal,
  openModal,
};

const mapStateToProps = (state) => {
  return {
    deviceDetails: state.core.deviceDetails,
    theme: state.theme,
  };
};

class RegistrationModal extends Component {
  render() {
    const { deviceDetails, theme } = this.props;
    const { isMobile } = deviceDetails;

    return (
      <div>
        <Modal
          open={true}
          closeOnEscape={true}
          closeOnDimmerClick={true}
          dimmer={true}
          onClose={() => { }}
          style={{
            margin: "0",
            padding: "0",
            top: "0",
            height: "100%",
            width: "100%",
            marginTop: "0px",
            backgroundColor: 'transparent',
            transform: "none",
            overflow: "hidden",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AppColumn
            crossAxisAlignment={"center"}
            mainAxisAlignment={"center"}
            style={{
              height: "100vh",
            }}
          >
            <AppColumn
              style={{
                height: isMobile ? "100%" : "90vh",
                width: isMobile ? "100%" : "40%",
                backgroundColor: theme.colors.white,
                borderRadius: isMobile ? "0px" : theme.radius.default,
              }}
            >
              <RegistrationPage asModal={true} closeModal={closeModal} />
            </AppColumn>
          </AppColumn>
        </Modal>
      </div>
    );
  }
}

export default connect(mapStateToProps, actions)(RegistrationModal);
export const MODAL_REGISTRATION = "RegistrationModal";
